import { ActivityEntityName, Entity } from '../../../../entities';
import { MergeField, MergeSchema, getSchema } from '../../decorators';

@MergeSchema({
    entity: ActivityEntityName.Contact
})
export class ContactFullMergeData {
    @MergeField()
    firstName: string;

    @MergeField()
    lastName: string;

    @MergeField()
    email: string;

    @MergeField()
    mobile: string;

    @MergeField()
    jobTitle: string;

    @MergeField({
        displayName: "Full name"
    })
    name: string;

    @MergeField({
        displayName: "Phone (home)"
    })
    phone: string;

    @MergeField({
        displayName: "Phone (work)"
    })
    workPhone: string;

    parents: Entity[]

    sites: Entity[]
}

export const ContactFullMergeSchema = getSchema(ContactFullMergeData);